var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.chatbotFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatbotButtonActivity,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatbotButtonActivity", $$v)
                  },
                  expression: "featureForm.chatbotButtonActivity",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.chatbotButtonActivity")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.maxSessionCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.maxSessionCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "maxSessionCount", $$v)
                },
                expression: "featureForm.maxSessionCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.storyCountLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.storyCountLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "storyCountLimit", $$v)
                },
                expression: "featureForm.storyCountLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.integrationCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.integrationCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "integrationCount", $$v)
                },
                expression: "featureForm.integrationCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.versionHistoryCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.versionHistoryCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "versionHistoryCount", $$v)
                },
                expression: "featureForm.versionHistoryCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.activeChatbotLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.activeChatbotLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "activeChatbotLimit", $$v)
                },
                expression: "featureForm.activeChatbotLimit",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }